// All user-facing error messages in Brazilian Portuguese.
// NEVER show raw errors, JSON, or technical messages to users.
// Map ALL errors through this map.

export const ERROR_MESSAGES: Record<string, string> = {
  'unauthorized':         'Faça login para continuar.',
  'insufficient_credits': 'Você não tem créditos suficientes. Adquira mais para continuar.',
  'timeout':              'A solicitação excedeu o tempo limite. Tente novamente em alguns instantes.',
  'no_birth_data':        'Para esta leitura, precisamos da sua data de nascimento. Adicione em Perfil.',
  'invalid_photo':        'Não conseguimos processar esta imagem. Tente com uma foto diferente.',
  'payment_failed':       'Houve um problema com o pagamento. Verifique seu cartão e tente novamente.',
  'network_error':        'Sem conexão com a internet. Verifique sua rede e tente novamente.',
  'generic':              'Algo não saiu como planejado. Tente novamente em alguns instantes.',
  'invalid_email':        'Endereço de e-mail inválido.',
  'weak_password':        'A senha precisa ter pelo menos 8 caracteres.',
  // RT-06: Non-confirming messages, never reveal whether email is registered
  'email_taken':          'Não conseguimos criar a conta com este email.',
  'invalid_credentials':  'Email ou senha incorretos. Verifique seus dados e tente novamente.',
  'email_not_confirmed':  'Confirme seu e-mail antes de entrar. Verifique sua caixa de entrada (e a pasta de spam).',
  'session_expired':      'Sua sessão expirou. Faça login novamente.',
  'coupon_invalid':       'Cupom inválido ou expirado.',
  'coupon_used':          'Este cupom já foi utilizado.',
  'gift_card_invalid':    'Cartão presente inválido ou já utilizado.',
};

/** RT-06: Detect email-already-exists errors without revealing the fact to users. */
export function isEmailTakenError(err: unknown): boolean {
  const msg = err instanceof Error ? err.message : String(err);
  const lower = msg.toLowerCase();
  return lower.includes('user already registered') ||
         lower.includes('already registered') ||
         lower.includes('email already');
}

export function getErrorMessage(key: string): string {
  return ERROR_MESSAGES[key] ?? ERROR_MESSAGES['generic'];
}

/** Map a raw error or error message to a user-friendly Portuguese string. */
export function mapError(err: unknown): string {
  if (!err) return ERROR_MESSAGES['generic'];
  const msg = err instanceof Error ? err.message : String(err);
  const lower = msg.toLowerCase();

  if (lower.includes('unauthorized') || lower.includes('jwt'))   return ERROR_MESSAGES['unauthorized'];
  if (lower.includes('timeout') || lower.includes('aborted'))    return ERROR_MESSAGES['timeout'];
  if (lower.includes('insufficient_credits'))                     return ERROR_MESSAGES['insufficient_credits'];
  if (lower.includes('no_birth_data'))                           return ERROR_MESSAGES['no_birth_data'];
  if (lower.includes('network') || lower.includes('fetch'))      return ERROR_MESSAGES['network_error'];
  if (lower.includes('invalid_credentials') ||
      lower.includes('invalid login') ||
      lower.includes('invalid email or password'))               return ERROR_MESSAGES['invalid_credentials'];
  if (lower.includes('email not confirmed') ||
      lower.includes('email link is invalid') ||
      lower.includes('confirmation'))                            return ERROR_MESSAGES['email_not_confirmed'];
  // RT-06: "User already registered" must not confirm email existence
  if (lower.includes('user already registered') ||
      lower.includes('already registered') ||
      lower.includes('email already'))                            return ERROR_MESSAGES['email_taken'];

  return ERROR_MESSAGES['generic'];
}
